import { render } from "./iconWrapper.vue?vue&type=template&id=21d7580b"
import script from "./iconWrapper.vue?vue&type=script&lang=js"
export * from "./iconWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__